import { render } from "./MainContainer.vue?vue&type=template&id=3694aab6&scoped=true"
import script from "./MainContainer.vue?vue&type=script&lang=js"
export * from "./MainContainer.vue?vue&type=script&lang=js"

import "./MainContainer.vue?vue&type=style&index=0&id=3694aab6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3694aab6"]])

export default __exports__